import axios from "axios";
import interceptors from "@/shared/api/interceptors";

const apiClientPayments = axios.create({
  baseURL: window.__CONFIG__.VUE_APP_BASE_DOMAIN + "/payments",
  withCredentials: true,
});

interceptors(apiClientPayments);

export default apiClientPayments;
